"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styles = require("../../../../../../styles");
var _Accordion = _interopRequireDefault(require("@mui/material/Accordion"));
var _AccordionSummary = _interopRequireDefault(require("@mui/material/AccordionSummary"));
var _AccordionDetails = _interopRequireDefault(require("@mui/material/AccordionDetails"));
var _ExpandMore = _interopRequireDefault(require("@mui/icons-material/ExpandMore"));
var _Grid = _interopRequireDefault(require("@mui/material/Grid"));
var _Box = _interopRequireDefault(require("@mui/material/Box"));
var _ = require("../../../../..");
var _Typography = _interopRequireDefault(require("@mui/material/Typography"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const NavItem = _ref => {
  let {
    title,
    items,
    href
  } = _ref;
  const theme = (0, _styles.useTheme)();
  const [activeLink, setActiveLink] = (0, _react.useState)('');
  (0, _react.useEffect)(() => {
    setActiveLink(window && window.location ? window.location.pathname : '');
  }, []);
  const hasActiveLink = () => items ? items.find(i => i.href === activeLink) : false;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_Accordion.default, {
      disableGutters: true,
      elevation: 0,
      sx: {
        backgroundColor: 'transparent'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionSummary.default, {
        expandIcon: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ExpandMore.default, {}),
        "aria-controls": "panel1a-content",
        id: "panel1a-header",
        sx: {
          padding: 0
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
          fontWeight: hasActiveLink() ? 600 : 400,
          color: hasActiveLink() ? 'primary' : 'text.primary',
          children: title
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionDetails.default, {
        sx: {
          padding: 0
        },
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
          container: true,
          spacing: 1,
          children: items ? items.map((p, i) => /*#__PURE__*/(0, _jsxRuntime.jsx)(_Grid.default, {
            item: true,
            xs: 12,
            children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_.Button, {
              size: 'large',
              component: 'a',
              href: p.href,
              fullWidth: true,
              sx: {
                justifyContent: 'flex-start',
                color: activeLink === p.href ? theme.palette.primary.main : theme.palette.text.primary,
                backgroundColor: activeLink === p.href ? (0, _styles.alpha)(theme.palette.primary.main, 0.1) : 'transparent',
                fontWeight: activeLink === p.href ? 600 : 400
              },
              children: [p.title, p.isNew && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Box.default, {
                padding: 0.5,
                display: 'inline-flex',
                borderRadius: 1,
                bgcolor: 'primary.main',
                marginLeft: 2,
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_Typography.default, {
                  variant: 'caption',
                  sx: {
                    color: 'common.white',
                    lineHeight: 1
                  },
                  children: "new"
                })
              })]
            })
          }, i)) : /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {})
        })
      })]
    })
  });
};
NavItem.propTypes = {
  title: _propTypes.default.string.isRequired,
  onClose: _propTypes.default.func
};
var _default = exports.default = NavItem;